import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Preferences } from '@capacitor/preferences';
import { ModalController, Platform} from '@ionic/angular';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
})


export class TermsComponent implements OnInit {


  constructor(private modalCtrl: ModalController,) {}




  accept(){
    let termsAcceptedOn: Date = new Date();

    const setTerms = async () => {
      try {
        await Preferences.set({
          key: 'TERMS_ACCEPTED_ON',
          value: JSON.stringify(termsAcceptedOn),
        });
  
        console.log('termsAcceptedOn saved');
  
        const result = await Preferences.get({ key: 'TERMS_ACCEPTED_ON' });
  
        console.log('Result from Preferences:', result);
        console.log('Value before conversion:', result.value);
  
        if (result.value != null) {
          const parsedDate = JSON.parse(result.value);
          const termsAcceptedOnDate: Date = new Date(parsedDate);
          console.log('Converted Date:', termsAcceptedOnDate);
        }
      } catch (error) {
        console.error('An error occurred while setting terms:', error);
      }
    };
  
    setTerms();
    

    this.modalCtrl.dismiss();
  }

  public startVideo() {
    try {
      const videoElement = document.querySelector('video') as HTMLVideoElement;
      const promise = videoElement.play();
  
      if (promise !== undefined) {
        promise.then(() => {
          console.log('Autoplay started!');
          // Autoplay started!
        }).catch(error => {
          console.log('Autoplay prevented:', error);
          // Autoplay was prevented.
          // Show a "Play" button so that the user can start playback.
        });
      }
  
      console.log('Video started playing successfully');
    } catch (error) {
      console.error('Video play error:', error);
      // Do stuff in case your video is unavailable to play/autoplay
    }
  }

  ngOnInit() {}

}
